import { render, staticRenderFns } from "./ActionAdministratorsCard.vue?vue&type=template&id=40b8fe6a&"
import script from "./ActionAdministratorsCard.vue?vue&type=script&lang=js&"
export * from "./ActionAdministratorsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports